import React, { useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import UserContext from '../../components/User_Context.js';
import * as menu from "../../assets/menus/menu.js"
import waiting from "../../assets/images/waiting.svg";
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import * as breadcrumb from "../../components/ui/breadcrumb.js";
import * as api from "../../api/apiConnector.js";
import StringListEditor from '../../components/stringListEditor.js';
import * as utils from "../../components/utils.js";
import { FileFolderSelector } from '../../components/fileFolderSelector.js';
import IconSelector from '../../components/Icon_Selector.js';
import IconFolder from '../../assets/icon/mimetype/icons8-folder.svg'
import folderSearch from '../../assets/icon/folder-search.svg'
import { dms_style } from "../../styles/style.js";
import * as icons from "../../components/fileTypesIcons.js";
import * as uploadManager from "../../components/ui/fileupload.js";
import cloud_icon from "../../assets/images/cloud.svg";
import { useTranslation } from 'react-i18next';


const Indicators_Evaluation_Screen = (params) => {
    const { t } = useTranslation();

    const { currentUser } = useContext(UserContext);
    const [indicator, setIndicators] = useState(null);
    const [requirement, setRequirement] = useState(null);
    const { indicatorId, organizationalUnitId = null } = useParams();
    const [linkData, setLinkData] = useState(null);
    const [valueData, setValueData] = useState(null);
    const [fileData, setFileData] = useState(null);
    const [toSave, setToSave] = useState(false);
    const [currentEvaluation, setCurrentEvaluation] = useState(null);
    let system_message_timer = null;
    const levelLabels = [
        t('pointOfAttention', { ns: 'labels' }),
        t('aspectToBeConsidered', { ns: 'labels' })
    ];

    useEffect(() => {
        _resizeTable();
        window.$(window).off("resize");
        window.$(window).on("resize", (e) => {
            _resizeTable();
        });

        (async () => {
            setBreadCrumb();
            menu.write({ user: currentUser() });
            await retrieveData();

        })();
    }, []);
    useEffect(() => {
        if (linkData) {
            _drawLinkTabs();
        }

    }, [linkData]);

    useEffect(() => {
        if (valueData) {
            _drawValueTabs();
        }
    }, [valueData]);

    useEffect(() => {
        if (fileData) {
            if (!window.$.fn.dataTable.isDataTable('.file-req-table')) {
                window.$(".file-req-table").DataTable({
                    paging: false,
                    searching: false,
                });
            }
            else {
                // resyncTableSource();
            }
        }
        window.$(".dataTables_empty").hide();
    }, [fileData]);


    const _tosave = () => {
        setToSave(true);
    }

    const selectFileModal = async (params) => {

        let _modal = window.$(`<div id="select-file-modal" class="modal modal-xl" tabindex="-1">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{t('chooseYourFile', { ns: 'labels' })}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p>Modal body text goes here.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
    
      </div>
    </div>
  </div>
</div>`);

        window.$("#select-file").remove();
        window.$("body").append(_modal);
        _modal.modal("show");
        const modal_body = _modal.find(".modal-body");

        FileFolderSelector({
            user: currentUser(),
            container: modal_body,
            drawFinder: true,
            onClick: async (f, type) => {
                show_system_message({
                    timeOut: 0,
                    message: `
                    <strong>Adding ${f.Name}</strong>...
                    `});

                var result = await addItem(f, type);

                if (result.addedd) {
                    show_system_message({
                        timeOut: 1500,
                        message: `
                        <strong>Added ${f.Name}</strong>...
                        `});

                    withReactContent(Swal).fire({
                        title: t('addingFile', { ns: 'labels' }),
                        icon: "info",
                        text: t('addingFileMessage', { ns: 'labels', fileName: f.Name }),
                        allowOutsideClick: false,
                        timer: 1000
                    });

                    setFileData(utils.clone(fileData));
                    _tosave();
                }
                else {
                    show_system_message({
                        timeOut: 1500,
                        message: `
                        <strong>Problem adding  ${f.Name}</strong>...
                        `});

                }

            }
        });
    }


    const _getAllFileInFolder = async (parentId) => {

        var result = await api.sendMessage("dms/retrieveAllFile", {
            user: currentUser(),
            body: {
                parentId: parentId
            }
        });

        return result.files;
    }

    const addItem = async (f, type) => {


        if (type == "folder") {
            let filesToAdd = [];

            var allFile = await _getAllFileInFolder(f.Id);


            if (allFile.length > 0) {
                fileData.push(...allFile);
                return { addedd: allFile }
            }
            else { return null }

        } else if (type == "file") {
            fileData.push(f);
            return { addedd: f }
        }
        else { return null }

    }


    const normItem = (item) => {
        if (item.ItemLastUpdated) item.ItemLastUpdated = new Date(item.ItemLastUpdated);
        if (item.ItemCreated) item.ItemCreated = new Date(item.ItemCreated);
        if (item.ItemDeleted) item.ItemDeleted = new Date(item.ItemDeleted);
    }

    const retrieveData = async () => {
        const indicatorResult = (await api.sendMessage("admin/indicators/get_all", {
            user: currentUser(),
            body: {
                indicatorId: indicatorId
            }
        }));




        const evaluationData = await api.sendMessage("indicator/evaluation/get", {
            user: currentUser(),
            body: {
                indicatorId: indicatorId
            }
        });

        //set indicator
        setIndicators(indicatorResult.indicators[0]);

        //set the evaluations
        setLinkData(evaluationData.links);
        setFileData(evaluationData.files);
        setValueData(evaluationData.values);

        var requirementList = indicatorResult?.user_indicators?.[0]?.Indicators?.[0]?.Requirements?.map(x => ({ Requirement: x.Requirement, Evaluation: x.Evaluation })) ?? [];

        setRequirement(requirementList);
    }


    const show_system_message = (params) => {
        const { message, timeOut = 2000 } = params;

        const inner_div = window.$(`<div class="col-xl-12">
            <div class="card dz-card">
                <div class="card-header flex-wrap border-0">
                    <div>
                        <h4 class="card-title">{t('aiPlan', { ns: 'labels' })}</h4>
                    </div>											
                </div>
                <div class="tab-content">
                    <div class="tab-pane fade active show" role="tabpanel">
                        <div class="card-body pt-0">
                            <h6><span></span>
                                <span class="pull-end"></span>
                            </h6>                                                                        
                        </div>
                    </div>
                </div>
    
            </div>
        </div>`);

        let div = window.$("#chat-system-message");

        if (div.length == 0) {
            div = window.$(`<div id="chat-system-message" style="position: fixed; right: 20px; bottom: 30px; width: 350px; height: 100px; opacity: 0.75"></div>`);
            window.$("body").append(div);
            div.append(inner_div);
        }

        const message_div = div.find(".pull-end");


        message_div.html("");
        message_div.append(window.$("<div/>").html(message));

        if (system_message_timer) {
            clearTimeout(system_message_timer);
        }

        if (timeOut > 0) {
            system_message_timer = setTimeout(() => {
                div.remove();
            }, timeOut);
        }
    }


    const _resizeTable = () => {
        const _height = window.$(window).height();
        const _responsive = window.$(".table-responsive");
        _responsive.css("height", _height - 120);
    }


    const setBreadCrumb = (params) => {
        var path = [{
            link: "/",
            name: t('home', { ns: 'labels' })
        },
        {
            link: "/admin/indicators",
            name: "Indicators"
        }
        ];
        breadcrumb.set(path);
    }

    const _evaluationModal = () => {
        if (currentEvaluation) {
            return (
                <>
                    <div class="modal-backdrop fade show"></div>
                    <div id="business_unit_edit_modal" className="modal fade show" style={{ display: "block" }} >
                        <div className="modal-dialog modal-xl  modal-dialog-centered modal-dialog-scrollable">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{currentEvaluation.Requirement.Name}</h5>
                                    <button type="button" className="btn-close" aria-label="Close"
                                        onClick={(e) => {
                                            setCurrentEvaluation(null);
                                        }}
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    {currentEvaluation.Evaluation.Values ? _drawListValues(`Value for the evaluation`, currentEvaluation.Evaluation.Values) : (null)}
                                    <br></br>
                                    {currentEvaluation.Evaluation.Links ? _drawListValues(`Link for the evaluation`, currentEvaluation.Evaluation.Links, 'link') : (null)}
                                    <br></br>
                                    {currentEvaluation.Evaluation.Links ? _drawFiles(currentEvaluation.Evaluation.Files) : (null)}

                                </div>

                            </div>
                        </div>
                    </div>
                </>
            )
        }
        else {
            return (null);
        }
    }

    const _drawFiles = (values) => {
        return (
            <>
                <h6>File for the evaluation</h6>
                <div >
                    {values.map(x => { return (_drawLiFileElement(x)) })}
                </div>
            </>
        )
    }
    const _drawLiFileElement = (file) => {
        return (<p>{file.Name}  <i class="fa-solid fa-download ms-2" style={{ cursor: "pointer"}}></i></p>)
    }

    const _drawListValues = (paragraph, values, type) => {


        return (
            <>
                <h6>{paragraph}</h6>
                <div >
                    {values.map(x => { return (_drawLiElement(x, type)) })}
                </div>
            </>
        )
    }

    const _drawLiElement = (value, type, index) => {
        if (type == 'link') {
            return (<a className="me-3 position-relative text-primary fs-13" href={value} target="_blank" > {index}  {value}</a>)

        } else {
            return (<p >{value}</p>)
        }

    }


    const _drawIndicatorArea = () => {

        return (
            <>
                <div className="card-header">
                    <h4 className="heading mb-0">{indicator.Code} - {indicator.Name}</h4>
                </div>
                <div className="card-body">
                    <h6>Evaluation for the requiremments</h6>
                    {_drawEvaluationRequirementTabs()}

                </div>


                {_drawTabs()}
            </>
        )

    }


    //#region evalutation requirement
    const _drawEvaluationRequirementTabs = () => {

        for (let r of requirement) {
            r.Requirement.level = 0;
            r.level = 0
            let _current = r;
            while (_current) {
                r.Requirement.level++;
                r.level++;
                _current = requirement.find(x => x.Requirement.Id == _current.Requirement.ParentId);
            }
        }

        const _rootNodes = requirement ? requirement.filter(x => x.level == 1)
            .sort((a, b) => { return a.Requirement.ItemOrder - b.Requirement.ItemOrder }) : [];

        const _countMaxLevel = (f, level) => {
            const _children = requirement.filter(x => x.Requirement.ParentId == f.Requirement.Id);
            f._childrenMaxLevel = level || 1;
            f._level = level || 1;
            for (const c of _children) {
                const _childMaxLevel = _countMaxLevel(c, (level || 1) + 1);

                if (_childMaxLevel > f._childrenMaxLevel) {
                    f._childrenMaxLevel = _childMaxLevel;
                };
            }

            return f._childrenMaxLevel;
        }

        const _drawTable = (node) => {
            const _getChildNodes = (n) => {
                const output = [n];
                const _children = requirement.filter(x => x.Requirement.ParentId == n.Requirement.Id);
                for (const c of _children) {
                    output.push(..._getChildNodes(c));
                }

                return output;
            }

            const _nodeData = _getChildNodes(node);

            let _data = _nodeData.filter(x => x._level == node._childrenMaxLevel);
            //.sort((a, b) => { return a.Requirement.ItemOrder - b.Requirement.ItemOrder });

            for (const d of _data) {
                let _current = d;
                while (_current) {
                    if (_current.Requirement.ParentId) {
                        _current.parent = _nodeData.find(x => x.Requirement.Id == _current.Requirement.ParentId);
                        _current = _current.parent;
                    }
                    else {
                        _current = null;
                    }
                }
            }

            for (const d of _data) {
                d._uiOrder = 0;
                let _current = d;
                let _level = 0;
                while (_current) {
                    d._uiOrder += _current.Requirement.ItemOrder * Math.pow(10, _level);
                    _current = _current.parent;
                    _level++;
                }
            }

            _data = _data.sort((a, b) => { return a._uiOrder - b._uiOrder });

            const _drawTr = (r) => {
                const _cells = [];
                const _getLevel = (node, l) => {
                    if (node._level > l) {
                        return _getLevel(node.parent, l);
                    }
                    else {
                        return node;
                    }
                }

                for (let level = 2; level <= r._level; level++) {
                    if (level == r._level
                        ||
                        _getLevel(r, level + 1).Requirement.ItemOrder == 0
                    ) {
                        const _node = _getLevel(r, level);
                        _cells.push(<td rowSpan={_node._childrenCount > 0 ? _node._childrenCount : 1} style={{ whiteSpace: "wrap" }} >
                            <strong>{_node.Requirement.Code}</strong> {_node.Requirement.Name} <br></br> {_counterEvaluation(_node)}</td>);
                        if (level == r._level) {
                            //_cells.push(<td style={{ fontSize: "0.5em", whiteSpace: "wrap" }}>{_node.Requirement.Notes}</td>);
                        }
                    }
                }

                return (<tr>{_cells}</tr>)
            }

            const _counterEvaluation = (req) => {
                if (req.Evaluation && req.Evaluation.Number > 0) {
                    return (<>
                        <a className="me-3 position-relative text-primary fs-13" href="#" onClick={() => { setCurrentEvaluation(req) }}>
                            {req.Evaluation.Number}  {req.Evaluation.Number == 1 ? `evaluation` : `evaluations`}
                        </a>
                    </>);
                }
                else {
                    <p> `No evaluation` </p>;
                }
            }

            const _drawHader = () => {
                const _levels = [];
                for (let i = 2; i <= node._childrenMaxLevel; i++) {
                    _levels.push(`${levelLabels[i - 2]}`);
                }
                //_levels.push("Notes");

                return (<tr>
                    {_levels.map((l) => {
                        return (<th>{l}</th>)
                    })}
                </tr>);
            }
            return (
                <table className="table">
                    <thead>
                        {_drawHader()}
                    </thead>
                    <tbody>
                        {_data.map((r) => {
                            return _drawTr(r);
                        })}
                    </tbody>
                </table>);
        }

        const _drawRootNode = (node, subLevel) => {
            _countMaxLevel(node);

            const _getTitle = () => {
                if (subLevel == 1) {
                    return (<h6 className="accordion-header">
                        <button aria-expanded="false" data-bs-target={`#node_div_${node.Id}`} className="accordion-button collapsed" type="button" data-bs-toggle="collapse">
                            {node.Requirement.Code} {node.Requirement.Name}
                        </button>
                    </h6>);
                }
                else {
                    <h6>{node.Requirement.Code} {node.Requirement.Name}</h6>
                }
            }

            return (<div className={subLevel == 1 ? "accordion-item" : null} data-bs-parent="accordion">
                {_getTitle()}
                <div id={`node_div_${node.Id}`} className={subLevel == 1 ? "accordion-collapse collapse" : null}>
                    <div className="small container">
                        {node.Requirement.Description}
                        <hr></hr>
                    </div>
                    {
                        (node._childrenMaxLevel == 3) ? (_drawTable(node)) : (<>
                            {requirement.filter(x => x.Requirement.ParentId == node.Requirement.Id)
                                .sort((a, b) => { return a.Requirement.ItemOrder - b.Requirement.ItemOrder })
                                .map(x => _drawRootNode(x, subLevel + 1))
                            }
                        </>)
                    }
                </div>

            </div>);
        }


        return (<div class="accordion">
            {_rootNodes

                .map((r) => {
                    return _drawRootNode(r, 1);
                })}
        </div>)



    }

    //#endregion

    const _drawTabs = () => {
        return (
            <>
                <ul class="nav nav-tabs" id="tabs" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active" id="file-tab" data-bs-toggle="tab" data-bs-target="#file-content" type="button" role="tab" aria-controls="file-content" aria-selected="false">Files</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="value-tab" data-bs-toggle="tab" data-bs-target="#value-content" type="button" role="tab" aria-controls="value-content" aria-selected="false">Values</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link" id="link-tab" data-bs-toggle="tab" data-bs-target="#link-content" type="button" role="tab" aria-controls="link-content" aria-selected="true">Links</button>

                    </li>
                </ul>
                <div class="tab-content" id="tabs-content" style={{ padding: 15 }}>
                    <div class="tab-pane fade active show" id="file-content" role="tabpanel" aria-labelledby="file-tab">
                        {_drawFileTabs()}
                    </div>
                    <div class="tab-pane fade" id="value-content" role="tabpanel" aria-labelledby="value-tab">
                        {_drawValueTabs()}
                    </div>
                    <div class="tab-pane fade" id="link-content" role="tabpanel" aria-labelledby="link-tab">

                        {_drawLinkTabs()}
                    </div>

                </div>
            </>

        )

    }

    const _drawLinkTabs = () => {
        return (<>
            <div class="col-lg-12 mb-3">
                <p class="fs-14">Here you can add the link that will be evaluated for this indicator</p>

                <StringListEditor data={linkData} columnName="Your links" dataType="string" dfuValue="" onChange={(e) => {
                    setLinkData(utils.clone(e));
                    _tosave();
                }}></StringListEditor>

            </div>
        </>)

    }

    const _drawValueTabs = () => {
        return (<>
            <div class="col-lg-12 mb-3">
                <p class="fs-14">Here you can add the value that will be evaluated for this indicator</p>


                <StringListEditor data={valueData} columnName="Your values" dfuValue="" dataType="textarea"
                    onChange={(e) => {
                        setValueData(utils.clone(e));
                        _tosave();
                    }}
                ></StringListEditor>

            </div>
        </>)

    }

    const getName = (item) => {
        const getPath = () => {
            if (item.item?.Path?.Path) {
                if (item.item?.Path?.Path.length > 0) {
                    return (<><small>in </small>
                        <a href={`/dms/${item.item.Path.Path[item.item.Path.Path.length - 1].Id}`}>
                            {(item.item.Path.Path.map(x => {
                                if (item.item.Path.Path.findIndex(y => y == x) == 0) {
                                    return (<small>{x.Name}</small>);
                                } else {
                                    return (<><small> / </small><small>{x.Name}</small></>);
                                }
                            }))}</a>
                    </>);
                }
            }
        }

        if (item.type === "folder") {
            return (<h6 style={{
                opacity: item.item.System_Item ? .5 : 1
            }}>
                <img width="28" height="28" src={IconFolder} alt='folder' />
                {item.item.Name}</h6>);
        }
        else {
            return (<>
                <h6>
                    <IconSelector icon={item.item.MimeType} />
                    {item.item.Name}</h6>
                {getPath()}
            </>);
        }
    }

    const getTableRow = (item) => {
        return (<tr key={`file_item.${item.item.Id}`} data-id={item.item.Id} style={{ ...dms_style.table_row }}>

            <td >
                <div data-id={item.item.Id} class="file-name">
                    <div>
                        {getName(item)}

                    </div>
                </div>
            </td>
            <td style={{ cursor: "pointer", textAlign: "center" }}
                onClick={(e) => {

                    show_system_message({
                        timeOut: 0,
                        message: `
                            <strong>Deleting ${item.item.Name} from the list</strong>...
                            `});




                    // if (result.deleted) {
                    show_system_message({
                        timeOut: 1500,
                        message: `
                                <strong> ${item.item.Name} deleted correctly</strong>...
                                `});
                    fileData.splice(fileData.findIndex(x => x.Id === item.item.Id), 1);

                    setFileData(utils.clone(fileData));
                    _tosave();


                }}
            ><i class="fa fa-trash me-2 text-secondary"></i></td>


        </tr>);
    }
    const getTableRows = () => {
        let _items = getItems();
        return _items.map((i) => { return (getTableRow(i)) });
    }


    const getItems = () => {


        let _files = fileData.map((i) => {
            normItem(i);

            return {
                type: "file",
                item: i
            }
        });

        let _output = [];

        for (var i of _files) {
            _output.push(i);
        }

        return _output;
    }
    const _frDraggingEffect = (e, show) => {

        const _path_parts = window.$(".breadcrumb").find("li").toArray();
        const _path = window.$(_path_parts[_path_parts.length - 1]).text();

        const _panel = window.$(`            
            <div id="dragging-bubble" class="bg-primary"             
            style="box-shadow: 2px 2px 2px 1px rgb(0 0 0 / 20%); z-index: 10000; position: fixed; bottom: 20px; transform: translateX(-50%); left: 50%; width: 300px; height: 80px; border-radius: 25px; opacity: .1;">
            <div id="dragging-bubble-icon" style="position: absolute; margin-top: -75px; width: 100%; text-align: center;"><img style="width: 100px" src="${cloud_icon}" /></div>
            <div style="position: relative; left: 0; top: 20px; width: 100%; text-align: center; color: white;">Drop files to upload them to</div>
            <div style="padding: 25px; position: relative; left: 0; top: 10px; width: 100%; text-align: center; color: white; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;"><i class="fa fa-folder-tree me-2"></i> ${_path}</div>
        </div>`);

        let _stopSignal = false;
        if (show) {
            if (window.$("#dragging-bubble").length == 0) {
                window.$("body").append(_panel);
                console.log("fr");
                _panel.fadeTo("slow", 1);

                let _direction = "up";

                const _animate = () => {
                    const _icon = window.$("#dragging-bubble-icon");
                    if (_direction == "up") {
                        _icon.animate({ "top": "-=25px" }, "slow", () => {
                            _direction = "down";
                            if (!_stopSignal) _animate();
                        });
                    } else {
                        _icon.animate({ "top": "+=25px" }, "slow", () => {
                            _direction = "up";
                            if (!_stopSignal) _animate();
                        });
                    }
                }

                _animate();
            }


        }
        else {
            _stopSignal = true;

            const _icon = window.$("#dragging-bubble-icon");
            _icon.animate({ "top": "-=1125px" }, "medium", () => {
                window.$("#dragging-bubble").remove();
            });
        }
    }

    const _drawFileTables = () => {




        if (!fileData) {
            return (<div class="text-center"><img src={waiting} /></div>);
        }

        return (
            <>

                <div className="tab-content">
                    <div className="tab-pane fade active show" id="document-list-panel" role="tabpanel" aria-labelledby="document-list-tab" tabindex="0">
                        <div class="container-fluid" onMouseOver={(e) => {
                            window.$("#draggableArea").removeClass("draggableArea");
                            _frDraggingEffect();
                        }}
                            onDragOver={(e) => {
                                window.$("#draggableArea").removeClass("draggableArea");
                                _frDraggingEffect();
                            }}
                        >
                            <div className='draggable-div' id="draggableArea"
                                onDragOver={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    if (e.dataTransfer && e.dataTransfer.items
                                        && e.dataTransfer.items.length > 0
                                    ) {

                                        for (const f of e.dataTransfer.items) {
                                            if (f.kind == "file") {
                                                const _icon = icons.iconMapping(f.type);
                                            }
                                        }
                                    }
                                }}
                                onMouseOut={(e) => {
                                    window.$("#draggableArea").removeClass("draggableArea");
                                }}
                                onDragEnter={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    window.$("#draggableArea").addClass("draggableArea");
                                    _frDraggingEffect(e, true);
                                }}
                                onDragEnd={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    window.$("#draggableArea").removeClass("draggableArea");
                                }}
                                onDragLeave={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    //  window.$("#draggableArea").removeClass("draggableArea");

                                }}
                                onDrop={async (e) => {
                                    window.$("#draggableArea").removeClass("draggableArea");
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const _files = await uploadManager.getAllFileEntries(e.dataTransfer.items);

                                    //if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
                                    if (_files.files && _files.files.length) {


                                        /*UPLOAD FILES HERE*/
                                        upload({
                                            files: _files.files, parentId: "documents", onFileAdded: (files) => {

                                                // var parentIDPath = content.path[content.path.length - 1].link;
                                                // let realUIDPath = parentIDPath.split("/");

                                                for (var f of files) {

                                                    normItem(f);
                                                    //todo addingFiles
                                                    fileData.push(f);
                                                    setFileData(utils.clone(fileData));
                                                    _tosave();
                                                }

                                            },


                                        });
                                    }
                                }}
                            >
                                <table className="table file-req-table" >

                                    <thead>
                                        <tr>
                                            <th className="col-11">Name</th>
                                            <th className="text-end col-1">Commands</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {fileData ? (getTableRows()) : (<div class="text-center"><img src={waiting} /></div>)}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </>);
    }

    const upload = async (params) => {
        params.user = currentUser();
        uploadManager.fileUpload(params);
    }

    const _drawFileTabs = () => {
        return (<>
            <div class="col-lg-12 mb-3 row ">
                <h6 class="col-md-12">Here you can add or search the link that will be evaluated for this indicator
                    <img src={folderSearch} class='ms-2' title={t('openSearchFiles', { ns: 'labels' })} style={{ cursor: "pointer" }} onClick={(e) => {
                        selectFileModal();
                    }}></img>
                </h6>
                {/* <button type="button" onClick={(e) => {
                    selectFileModal();
                }}
                    className="btn btn-primary col-md-3">Search in your DMS</button> */}
                {_drawFileTables()}
            </div>
        </>)

    }

    const _validate = () => {
        const errors = [];

        if (!toSave) {
            var error = `Nothing to save`
            errors.push(error);
        }


        //checking link
        if (linkData.length > 0) {
            let linkDataNullValue = false;

            for (const ld of linkData) {

                if (ld == "") {
                    linkDataNullValue = true;
                }
            }

            if (linkDataNullValue) {
                var error = `There is a empty value in the links`
                errors.push(error);
            }

        }

        //checking value
        if (valueData.length > 0) {
            let valueDataNullValue = false;

            for (const vd of valueData) {

                if (vd == "") {
                }
            }

            if (valueDataNullValue) {
                var error = `There is a empty value in the values`
                errors.push(error);
            }

        }

        return errors;

    }

    const _saveIndicatorEvaluation = async () => {
        let errors = _validate();



        withReactContent(Swal).fire({
            title: t('saving', { ns: 'labels' }),
            icon: "info",
            text: t('saveData', { ns: 'labels' }),
            allowOutsideClick: false
        });

        if (errors.length > 0) {
            withReactContent(Swal).fire({
                title: t('error', { ns: 'labels' }),
                icon: "error",
                text: errors.join(','),
                showConfirmButton: true,

            });
        }
        else {

            const result = await api.sendMessage("indicators/evaluation/save", {
                user: currentUser(),
                body: {
                    indicatorId: indicatorId,
                    organizationalUnitId: organizationalUnitId,
                    files: fileData,
                    links: linkData,
                    values: valueData
                }

            });

            if (result.message) {
                withReactContent(Swal).fire({
                    title: t('error', { ns: 'labels' }),
                    icon: "error",
                    text: result.message,
                    showConfirmButton: true
                });
            }
            else {
                withReactContent(Swal).fire({
                    title: t('success', { ns: 'labels' }),
                    icon: "success",
                    text: `${result.updated.length} evaluation updated with success`,
                    showConfirmButton: true
                });

                setToSave(false);
            }


        }

    }


    return (
        <>
            <div className="page-titles">
                <ol className="breadcrumb">
                </ol>
                <div>


                    <a className="text-primary fs-13" onClick={(e) => {
                        _saveIndicatorEvaluation();
                    }} role="button" title={t('saveData', { ns: 'labels' })}><i className="fa-solid fa-floppy-disk fa-2x"></i></a>
                </div>
            </div>

            <div style={{
                width: "100%",
                overflow: "scroll"

            }}>
            </div>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="tab-content" id="tabs-content" style={{ padding: 15 }}>
                                    {indicator ? (
                                        <>
                                            {_drawIndicatorArea()}
                                            {_evaluationModal()}
                                        </>) : <div className="text-center"><img src={waiting} /></div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export { Indicators_Evaluation_Screen }